import { bluePaletteDark, grayPaletteDark } from '../../themes/dark-colors';

export const cardDarkTheme = {
  backgroundColor: grayPaletteDark[0],
  borderColor: grayPaletteDark[300],
  highlight: {
    backgroundColor: grayPaletteDark[200],
    borderColor: bluePaletteDark[400],
  },
  footer: {
    backgroundColor: grayPaletteDark[100],
    color: grayPaletteDark[800],
    lineHeight: '20px',
  },
};
